module.exports = "<app-slider></app-slider>\r\n<app-category-summary></app-category-summary>\r\n<app-page-connections></app-page-connections>\r\n\r\n"